import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable({
    providedIn: "root",
  })
export class ModalSancionesPersonaService{
    private API_URL;
  
    constructor(
      private http: HttpClient,
      private enviromentGlobalService: EnviromentGlobalService
    ) {
      this.API_URL = this.enviromentGlobalService.apiUrl;
    }
    innactivarSancion(entry: any,file: File):Observable<any>{
        const formData = new FormData();
        formData.append("sancion_id", entry.sancion_id);
        formData.append("motivo", entry.motivo);
        if(file && file.size > 0){
          formData.append("nombre_archivo", file.name);
          formData.append("archivo", file, file.name);
        }
        const uploadReq = new HttpRequest(
          "POST",
          `${this.API_URL}/SancionesPersonas/Inactivar/${entry.sancion_id}`,
          formData,
        );
        return this.http.request<any>(uploadReq).pipe(retry(2));
    }
    eliminarSancion(entry: any,file: File):Observable<any>{
      const formData = new FormData();
      formData.append("sancion_id", entry.sancion_id);
      formData.append("motivo", entry.motivo);
      
      if(file && file.size > 0){
        formData.append("archivo", file, file.name);
        formData.append("nombre_archivo", file.name);
      }
      const uploadReq = new HttpRequest(
        "POST",
        `${this.API_URL}/SancionesPersonas/Eliminar/${entry.sancion_id}`,
        formData,
      );
      return this.http.request<any>(uploadReq).pipe(retry(2));
  }
}